<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Fiyat</label>
            <input type="text" class="form-control" placeholder="Fiyat" v-model="value.Price"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Başlangıç Tarihi</label>
            <flat-pickr v-model="value.EffectivePriceDate" class="form-control" :config="{altInput:true, altFormat:'d.m.Y',dateFormat: 'Y-m-d', locale:'tr'}" placeholder="Başlangıç Tarihi"/>
        </div>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/l10n/tr.js' 
export default {
    components:{
        flatPickr
    },
    props:{
        value:Object,
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>